<section class="testimonios">
<div class=" container-fluid container-xl py-5">
  <h2 class="text-center font-weight-bold mb-5">Testimonios</h2>
  
  <div class="row">
    <div class="col-12">
    <ngx-slick-carousel
      class="carousel"
      [config]="slickConfig">

    <div ngxSlickItem *ngFor="let testimonio of testimonios">
      <div class="card shadow-sm py-5 px-4 border-0">
        <div class="d-flex align-items-center mb-3">
          <span class="mr-2" style="font-size: 1.2rem;">🗣️</span>
          <h5 class="mb-0 font-weight-bold">{{ testimonio.nombre }}</h5>
        </div>
        <p class="mb-0">{{ testimonio.mensaje }}</p>
      </div>
    </div>
    </ngx-slick-carousel>
    </div>

  </div>
</div>
</section>